import { VeeValidate } from '../vue.bundle';
import debounce from '../utils/debounce';

VeeValidate.Validator.extend('pwd', {
    getMessage: field => '*',
    validate: (value) => {
        let pattern = /(?=^.{8,20}$)((?=.*\d)(?=.*[A-Z])(?=.*[a-z])|(?=.*\d)(?=.*[^A-Za-z0-9])(?=.*[a-z])|(?=.*[^A-Za-z0-9])(?=.*[A-Z])(?=.*[a-z])|(?=.*\d)(?=.*[A-Z])(?=.*[^A-Za-z0-9]))^.*/;
        return pattern.test(value);
    }
});

VeeValidate.Validator.extend('fwUsername', {
    getMessage: field => '*',
    validate: (value) => {
        let pattern = /^[a-zA-Z0-9\.\-_]{2,20}$/;
        return pattern.test(value);
    }
});

VeeValidate.Validator.extend('fwEmail', {
    getMessage: field => '*',
    validate: (value) => {
        let pattern = /^[\w!\'.-]*[a-zA-Z0-9'_]@[\w\.-]*[a-zA-Z0-9]\.[a-zA-Z][a-zA-Z\.]*[a-zA-Z]$/;
        return pattern.test(value);
    }
});

VeeValidate.Validator.extend('validInput', {
    getMessage: field => '*',
    validate: (value) => {
        let pattern = /^[^<>/`^]*$/;
        return pattern.test(value);
    }
});

export default {
    name: 'RegistrationModule',
    template: '#cmp-registration',
    data() {
        return {
            token: '',
            userSharedID: '',
            username: '',
            locale: 'en-us',
            password: '',
            passwordConfirm: '',
            email: '',
            salutation: 0,
            firstName: '',
            surname: '',
            title: '',
            phone: '',
            mobile: '',
            address1: '',
            address2: '',
            city: '',
            state: '',
            postCode: '',
            country: '',
            timeZone: 1,
            timeZones: [],
            salutations: [],
            locales: [],
            countries: [],
            step: 1,
            showSuccess: false,
            showError: false,
            showErrorToken: false,
            showForm: false,
            submitting: false,
            invalidEmail: undefined,
            requestVerificationToken: '',
            NonZDC: false,
            isEditable: true,
            showPasswordInValid: false,
            isTermsAccepted: false,
        };
    },
    watch: {
        email(n, o) {
            let self = this;
            if (n && /^[\w!\.-]*[a-zA-Z0-9_]@[\w\.-]*[a-zA-Z0-9]\.[a-zA-Z][a-zA-Z\.]*[a-zA-Z]$/.test(n)) {
                self.validateEmail();
            }
        },
        username(n, o) {
            if (n && /^[a-zA-Z0-9\.\-_]{2,20}$/.test(n)) {
                this.validateUsername();
            }
        }
    },
    computed: {
    },
    methods: {
        setStep(step) {
            this.submitting = false;
            this.step = step;
            if (step == 2) {
                if (this.isTermsAccepted) {
                    this.submitting = false;
                }
                else {
                    this.submitting = true;
                }
            }
            else {
                this.submitting = false;
            }
            return false;
        },
        continueRegistration() {
            let self = this;
            self.showPasswordInValid = false;
            self.$validator.validateAll().then((valid) => {
                var errors = self.$validator.errors.items.length;
                if (valid && errors === 0) {
                    self.setStep(2);
                }
            });
        },
        completeRegistration() {
            let self = this;
            self.showPasswordInValid = false;
            self.$validator.validateAll().then((valid) => {
                if (valid) {
                    self.submitting = true;

                    let data = {
                        token: self.token,
                        userSharedID: self.userSharedID,
                        username: self.username,
                        locale: self.locale,
                        password: self.password,
                        passwordConfirm: self.passwordConfirm,
                        email: self.email,
                        salutation: self.salutation,
                        firstName: self.firstName,
                        surname: self.surname,
                        title: self.title,
                        phone: self.phone,
                        mobile: self.mobile,
                        address1: self.address1,
                        address2: self.address2,
                        city: self.city,
                        state: self.state,
                        postalCode: self.postCode,
                        country: self.country,
                        timeZone: self.timeZone,
                        isEditable: self.isEditable,
                        isTermsAccepted: self.isTermsAccepted,
                    };

                    $.ajax({
                        type: 'post',
                        url: '/api/invite/' + self.token,
                        dataType: 'json',
                        contentType: 'application/json',
                        data: JSON.stringify(data),
                        headers: { 'X-CSRF-TOKEN': self.requestVerificationToken }
                    })
                        .done((r) => {
                            self.showSuccess = true;
                            self.showForm = false;
                        })
                        .fail((r) => {
                            if (r.status === 400) {
                                let resp = r.responseJSON;
                                if (resp.validInvite) {
                                    if (!resp.validUsername) {
                                        self.$validator.errors.add('username', 'wrong', 'taken');
                                    }

                                    if (!resp.validEmail) {
                                        self.$validator.errors.add('email', 'wrong', 'taken');
                                    }

                                    self.setStep(1);
                                } else {
                                    if (resp.passwordInValid) {
                                        self.showPasswordInValid = true;
                                        self.setStep(1);
                                    }
                                    else if (!resp.validInvite && !resp.valid) {
                                        self.showError = true;
                                        self.showForm = false;
                                    }
                                    else {
                                        self.showErrorToken = true;
                                        self.showForm = false;
                                    }
                                }
                            } else {
                                self.showError = true;
                            }
                        });
                }

                return valid;
            });
        },
        validateToken() {
            let self = this;

            $.ajax({
                type: 'post',
                url: '/api/invite/validate',
                dataType: 'json',
                contentType: 'application/json',
                data: JSON.stringify(self.token),
                headers: { 'X-CSRF-TOKEN': self.requestVerificationToken }
            })
                .done((r) => {
                    if (r.valid) {
                        self.showForm = true;
                        self.getForm();
                        self.getInvite();
                    } else {
                        self.showErrorToken = true;
                    }
                })
                .fail(() => {
                    self.showError = true;
                    self.submitting = false;
                });
        },
        validateUsername: debounce(function () {
            let self = this;
            let data = {
                username: self.username,
                userSharedID: self.userSharedID
            };

            self.submitting = true;
            self.$validator.errors.remove('username');

            $.ajax({
                type: 'post',
                url: '/api/account/validation/username',
                dataType: 'json',
                contentType: 'application/json',
                data: JSON.stringify(data),
                headers: { 'X-CSRF-TOKEN': self.requestVerificationToken }
            })
                .done((r) => {
                    if (r.valid) {
                    } else {
                        self.$validator.errors.add('username', 'wrong', 'taken');
                    }
                    self.submitting = false;
                })
                .fail(() => {
                    self.showError = true;
                    self.submitting = false;
                });
        }, 1000)
        ,
        validateEmail: debounce(function () {
            let self = this;
            let data = {
                email: self.email,
                userSharedID: self.userSharedID
            };

            self.submitting = true;
            self.$validator.errors.remove('email');

            $.ajax({
                type: 'post',
                url: '/api/account/validation/email',
                dataType: 'json',
                contentType: 'application/json',
                data: JSON.stringify(data),
                headers: { 'X-CSRF-TOKEN': self.requestVerificationToken }
            })
                .done((r) => {
                    if (r.valid) {
                    } else {
                        self.$validator.errors.add('email', 'wrong', 'taken');
                    }
                    self.submitting = false;
                })
                .fail(() => {
                    self.showError = true;
                    self.submitting = false;
                });
        }, 1000)
        ,
        getForm() {
            let self = this;

            $.getJSON('/api/invite/form')
                .done((r) => {
                    self.countries = r.countries;
                    self.locales = r.locales;
                    self.salutations = r.salutations;
                    self.timeZones = r.timeZones;
                })
                .fail(() => {
                    self.showError = true;
                    self.submitting = false;
                });
        },
        getInvite() {
            let self = this;

            $.getJSON('/api/invite/' + self.token)
                .done((r) => {
                    if (r.valid) {
                        self.showForm = true;
                        self.userSharedID = r.data.sharedID;
                        self.username = r.data.username;
                        self.firstName = r.data.firstName;
                        self.surname = r.data.surname;
                        self.salutation = r.data.salutation;
                        self.title = r.data.title;
                        self.username = r.data.username;
                        self.email = r.data.email;
                        self.locale = r.data.locale;
                        self.timeZone = r.data.timeZone;
                        self.phone = r.data.phone;
                        self.mobile = r.data.mobile;
                        self.address1 = r.data.address1;
                        self.address2 = r.data.address2;
                        self.city = r.data.city;
                        self.state = r.data.state;
                        self.postCode = r.data.postalCode;
                        self.country = r.data.country;
                        self.isEditable = r.data.isEditable;
                        self.isTermsAccepted = !self.isEditable
                    } else {
                        self.showForm = false;
                        self.showErrorToken = true;
                    }
                })
                .fail(() => {
                    self.showError = true;
                    self.submitting = false;
                });
        },
        setRequestVerificationToken() {
            this.requestVerificationToken = $('input[name=__RequestVerificationToken]').val();
        },
        checkedTermsConditions() {
            this.submitting = false;
            this.isTermsAccepted = !this.isTermsAccepted;
            if (this.isTermsAccepted) {
                this.submitting = false;
            }
            else {
                this.submitting = true;
            }
        }
    },
    created() {
        let self = this;
        self.token = self.$route.params.token;
        self.setRequestVerificationToken();
        self.validateToken();
        toggleRegisterLoginMsg(false);
    }
}


// WEBPACK FOOTER //
// ./src/scripts/vue/components/Registration.js